// Vertrag zur Auftragsverarbeitung (AV-Vertrag, Art. 28 DSGVO) mit Lehrkräften.
// DPA_VERSION MUSS mit server/services/dpa.py übereinstimmen (server/tests/test_dpa.py
// prüft das). Bei jeder inhaltlichen Änderung an pages/AvVertrag.tsx beide Konstanten
// hochziehen – Lehrkräfte mit älterer Fassung sehen dann erneut den Zustimmungsdialog.
export const DPA_VERSION = '2026-09-29';

/** Anzeige der Fassung, z. B. „29.09.2026“. */
export const DPA_VERSION_LABEL = DPA_VERSION.split('-').reverse().join('.');

export const DPA_PATH = '/av-vertrag';
